import { supabase } from '@/integrations/supabase/client';
import { enrichPromptForFileCreation } from './supabaseServices';

export const callQwenAI = async (prompt: string) => {
  try {
    // System prompt is now injected server-side by the qwen-chat edge function
    const { data, error } = await supabase.functions.invoke('qwen-chat', {
      body: {
        messages: [
          { role: 'user', content: enrichPromptForFileCreation(prompt) }
        ],
        temperature: 0.7,
        max_tokens: 4096,
        model: 'qwen/qwen3-32b',
        stream: false  // Disable streaming to get proper JSON response
      },
    });

    if (error) {
      console.error('Error calling Qwen AI:', error);
      throw new Error(`Failed to get response from Qwen AI: ${error.message}`);
    }

    const raw: string = (data?.content as string) || '';
    // Extract <think>...</think> block if present
    let reasoning: string | null = null;
    let response = raw;
    if (typeof raw === 'string') {
      const match = raw.match(/<think>([\s\S]*?)<\/think>/i);
      if (match && match[1]) {
        reasoning = match[1].trim();
        response = raw.replace(/<think>[\s\S]*?<\/think>/i, '').trim();
      }
    }

    return {
      response: response || 'No response from Qwen AI',
      reasoning,
    };
  } catch (error) {
    console.error('Error in callQwenAI:', error);
    throw new Error(`Error communicating with Qwen AI: ${error instanceof Error ? error.message : String(error)}`);
  }
};
